import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.8.668a1 1 0 0 0-.551.281l-1.67 1.67c-1.49 1.49-1.49 3.93 0 5.41l.668.668 1.66 1.67.004.004c1.05 1.05 2.57 1.32 3.9.885l.236.236-2.79 2.79a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l4-4a1 1 0 0 0 0-1.41 1 1 0 0 0-1.01-.242l1.35-1.34a1 1 0 0 0 .004-1.42L16.67.94a1 1 0 0 0-.863-.281zm-3.84 7.33a1 1 0 0 0-.707.293l-8.37 8.37a2.02 2.02 0 0 0 0 2.83l1.59 1.59c.773.772 2.06.772 2.83 0l8.37-8.37a1 1 0 0 0 0-1.41 1 1 0 0 0-1.41 0l-1.59-1.59a1 1 0 0 0 0-1.41 1 1 0 0 0-.707-.293z" }, null, -1)
  ]))]))
}
export default { render: render }